import { render, staticRenderFns } from "./LitterRequestCard.vue?vue&type=template&id=047999cd"
import script from "./LitterRequestCard.vue?vue&type=script&lang=ts"
export * from "./LitterRequestCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports